import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticateService } from './authenticate.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public router: Router,
    private authService: AuthenticateService
  ) { }

  getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }

  public loginUser() {
    this.router.navigate(["/enetassess"]);
  }

  public goToEnetassess() {
    this.router.navigate(["/enetassess"]);
  }

  public goToFeedback(){
    this.router.navigate(["/feedback"]);
  }

  public logoutUser(enetsecure) {
    this.authService.disconnect();
    if(enetsecure !== null && enetsecure !== undefined && enetsecure !== ""){
      window.location.href = "login?" + enetsecure;
    }    
    else{
      window.location.href = "login";
    }
  }

  public alreadyLoggedIn(){
    this.authService.disconnect();
    window.location.href = "/login.aspx?es=1";
  }

  public redirectToSecureDownload(forumUrl){
    this.authService.disconnect();
    window.location.href = forumUrl;
  }

  public launchExam() {
    
    this.router.navigate(["/loadexam"]);
  }

  public launchExamQuestions() {
    this.router.navigate(["/questions"]);
  }
}
